import React from 'react';
export type MetaItem = {
  label: string;
  value: string;
  /** Optional supporting line beneath the value — used by results figures. */
  note?: string;
};
type MetaRowProps = {
  items: MetaItem[];
  /** Renders the value at figure scale, for results and studio numbers. */
  scale?: 'default' | 'figure';
  className?: string;
  'aria-label'?: string;
};

/**
 * One metadata row, shared by case-study facts, studio numbers and results.
 * Rules between items, no cards.
 */
export function MetaRow({
  items,
  scale = 'default',
  className = '',
  ...rest
}: MetaRowProps) {
  return <dl className={`grid grid-cols-2 gap-x-8 gap-y-10 border-t border-line pt-8 md:grid-cols-4 ${className}`} {...rest} data-id="element-256" data-mp="2a9t11vyvzv2">
      {items.map(item => <div key={item.label} data-id="element-257" data-mp="3ugezwy35egrf">
          <dt className="t-label text-subtle" data-id="element-258" data-mp="c862zqd64orl">{item.label}</dt>
          <dd className={`${scale === 'figure' ? 't-h2' : 't-h3'} mt-3 text-ink`} data-id="element-259" data-mp="c6l9m42lbbvb">
            {item.value}
          </dd>
          {item.note && <p className="t-small mt-2 text-mut" data-id="element-260" data-mp="1yfbcx366ymw2">{item.note}</p>}
        </div>)}
    </dl>;
}